<template>
  <va-create-layout>
    <fields-form :title="title" :item="item"></fields-form>
  </va-create-layout>
</template>

<script>
export default {
  props: ['title', 'item'],
}
</script>
